import { tracking } from '@iwoca/frontend-tracking-library';
import { Trans } from '@lingui/react/macro';

import styles from './Help.module.css';
import { useLocale } from '../../../hooks/useLocale';
import { getAmplitudeDefaultEventProperties } from '../../../utils/amplitudeEvents';
import IconWithText from '../../IconWithText/IconWithText';

type THelpType = 'FAQ' | 'phone' | 'email';

const HelpContents = () => {
  const { isDE } = useLocale();

  const handleTrackClickHelpLink = (helpType: THelpType) => {
    tracking.ampli.helpMethodSelected({
      CTA_type: helpType,
      ...getAmplitudeDefaultEventProperties(),
    });
  };

  const supportNumber = isDE ? '06994323020' : '02037780105';
  const supportEmail = isDE ? 'support@iwoca.de' : 'support@iwoca.co.uk';

  return (
    <div className={styles.helpItems}>
      <IconWithText className={styles.helpItem} icon="questionMarkFilled">
        <Trans>
          Find answers in our{' '}
          <a
            href="/faq/"
            target="_blank"
            rel="noreferrer"
            onClick={() => handleTrackClickHelpLink('FAQ')}
          >
            FAQ
          </a>
        </Trans>
      </IconWithText>
      <IconWithText className={styles.helpItem} icon="phoneFilled">
        <Trans>
          Call us on{' '}
          <a
            href={`tel:${supportNumber}`}
            target="_blank"
            rel="noreferrer"
            onClick={() => handleTrackClickHelpLink('phone')}
          >
            020 3778 0105
          </a>
        </Trans>
        <div>
          <Trans>Monday to Friday (9am - 6pm)</Trans>
        </div>
      </IconWithText>
      <IconWithText className={styles.helpItem} icon="emailFilled">
        <Trans>
          Email us at{' '}
          <a
            href={`mailto:${supportEmail}`}
            target="_blank"
            rel="noreferrer"
            onClick={() => handleTrackClickHelpLink('email')}
          >
            support@iwoca.co.uk
          </a>
        </Trans>
      </IconWithText>
    </div>
  );
};

export default HelpContents;
